/* Minimal app logger. Silenced in production builds; verbose in dev.
 * For real prod observability, point shipError at Sentry/Datadog/etc. */
const isDev = process.env.NODE_ENV !== "production";

export const log = {
  debug: (...a) => { if (isDev) console.debug("[220]", ...a); },
  info:  (...a) => { if (isDev) console.info("[220]", ...a); },
  warn:  (...a) => { if (isDev) console.warn("[220]", ...a); },
  error: (...a) => { if (isDev) console.error("[220]", ...a); },
};

export function shipError(error, info) {
  // Hook point for prod telemetry. No-op for now.
  if (isDev) console.error("[220:shipError]", error, info);
}
